import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { firebase } from "astrid-firebase";
import { updateDocument } from "astrid-firestore/src/helpers";

import { useProfile } from "../../../authentication/state/profile";
import Table from "../../../tables/components/Table";

import HomeLayout from "../../layouts/HomeLayout/HomeLayout";

import useAlertProductions from "./hooks/useAlertProductions";
import useAlertsColumns from "./hooks/useAlertsColumns";

export default function AlertsWidget({ language }) {
	const { t } = useTranslation();

	const user = useProfile();
	const navigate = useNavigate();

	const data = useAlertProductions({ language });
	const columns = useAlertsColumns();

	const getDropdownMenuOptions = (production) => [
		{
			text: t("toProduction", "To production"),
			linkTo: `/production/${production.id}`,
		},
		{
			text: t("removeReminder", "Remove reminder"),
			action() {
				return updateDocument(user.ref, {
					[`alertProductions.${production.id}`]: firebase.firestore.FieldValue.delete(),
				});
			},
		},
	];

	return (
		<HomeLayout.Widget icon="alarm" color="purple" header={t("reminders")}>
			<Table
				data={data}
				columns={columns}
				onClick={({ id }) => navigate(`/production/${id}`)}
				getDropdownMenuOptions={getDropdownMenuOptions}
				noDataAvailableMessage={t("youHaveNoReminders", "You have no reminders")}
			/>
		</HomeLayout.Widget>
	);
}
